import RProgressApi from './api/index';
import RProgress from './components/RProgress/index';

export { RProgress, RProgressApi };
